document.addEventListener('rebuy:cart.ready', (event) => {
  const cart = event.detail.cart.cart;
  const titleEl = document.querySelector('#rebuy-cart-title');

  if (!titleEl) {
    return;
  }

  const existing = titleEl.querySelector('.cart-count');
  if (existing) existing.remove();

  const countEl = document.createElement('span');
  countEl.className = 'cart-count';
  countEl.textContent = `(${cart.item_count})`;

  titleEl.append(countEl);
});


document.addEventListener('rebuy:cart.change', function (event) {
  const cart = event.detail.cart.cart;
  const titleEl = document.querySelector('#rebuy-cart-title');

  if (titleEl) {
    const existing = titleEl.querySelector('.cart-count');
    if (existing) existing.remove();

    const countEl = document.createElement('span');
    countEl.className = 'cart-count';
    countEl.textContent = `(${cart.item_count})`;

    titleEl.append(countEl);
  }

});

document.addEventListener('shopify:block:select', (event) => {
  const panel = event.target.closest?.('.image-with-text-tabbed__panel');
  if (!panel) return;

  const tabs = panel.closest('.shopify-section')?.querySelector('tabs-element');
  if (!tabs) return;

  const index = Array.from(tabs.querySelectorAll('button[role="tab"]')).findIndex(
    (button) => button.getAttribute('aria-controls') === panel.id
  );

  if (index > -1) tabs.selectedIndex = index;
});

(function () {
  'use strict';

  var CONFIG = {
    widget: '.rebuy-widget.widget-type-product-addon',
    item: '.rebuy-addon__item',
    addButton: '.rebuy-addon__item-learn-more-link',
    title: '.rebuy-addon__item-product-title',
    image: '.rebuy-addon__item-image',
    variantSelect: 'select.rebuy-select',

    linkClass: 'rebuy-addon__item-link',
    enhancedAttr: 'data-xsell-enhanced',
    busyAttr: 'data-xsell-adding',
    doneAttr: 'data-xsell-added',

    addedText: 'Add',
    addedDuration: 2000
  };

  /* ---------- helpers ---------------------------------------------------- */

  function closest(node, selector) {
    if (!node) return null;
    var el = node.nodeType === 1 ? node : node.parentElement;
    return el && el.closest ? el.closest(selector) : null;
  }

  function cartAddUrl() {
    var routes = window.theme && window.theme.routes;
    return (routes && routes.cart_add_url) || '/cart/add.js';
  }

  // The Add link's href carries handle + ?variant= + Rebuy attribution params.
  function productUrl(item) {
    var link = item.querySelector(CONFIG.addButton);
    return link ? link.getAttribute('href') : null;
  }

  // Prefer the <select>: its option values are the raw variant IDs, so we
  // never race Rebuy rewriting the Add link's href after a variant change.
  function variantId(item) {
    var select = item.querySelector(CONFIG.variantSelect);
    if (select && select.value) return select.value;

    var link = item.querySelector(CONFIG.addButton);
    if (!link) return null;
    try {
      return new URL(link.getAttribute('href'), window.location.origin)
        .searchParams.get('variant');
    } catch (err) {
      return null;
    }
  }

  function productTitle(item) {
    var el = item.querySelector(CONFIG.title);
    return el ? el.textContent.trim() : '';
  }

  /* ---------- DOM enhancement -------------------------------------------- */

  // Wrap the contents of `host` in an <a>, or update the href if already done.
  function linkify(host, href, options) {
    if (!host || !href) return;
    options = options || {};

    var existing = host.querySelector('.' + CONFIG.linkClass);
    if (existing) {
      if (existing.getAttribute('href') !== href) existing.setAttribute('href', href);
      return;
    }

    var anchor = document.createElement('a');
    anchor.className = CONFIG.linkClass;
    anchor.setAttribute('href', href);

    if (options.decorative) {
      // Image duplicates the title link — hide it from AT and tab order.
      anchor.setAttribute('tabindex', '-1');
      anchor.setAttribute('aria-hidden', 'true');
    } else if (options.label) {
      anchor.setAttribute('aria-label', options.label);
    }

    while (host.firstChild) anchor.appendChild(host.firstChild);
    host.appendChild(anchor);
  }

  function enhanceItem(item) {
    var href = productUrl(item);
    if (!href) return;

    var title = productTitle(item);

    linkify(item.querySelector(CONFIG.title), href, {
      label: title ? 'View ' + title : null
    });
    linkify(item.querySelector(CONFIG.image), href, { decorative: true });

    // The Add link behaves as a button. The href is intentionally left in
    // place so that, if this script fails to run, it degrades to Rebuy's
    // original "link to the product page" behaviour.
    var button = item.querySelector(CONFIG.addButton);
    if (button && !button.hasAttribute('role')) {
      button.setAttribute('role', 'button');
    }

    item.setAttribute(CONFIG.enhancedAttr, 'true');
  }

  function enhanceAll() {
    var widgets = document.querySelectorAll(CONFIG.widget);
    for (var i = 0; i < widgets.length; i++) {
      var items = widgets[i].querySelectorAll(CONFIG.item);
      for (var j = 0; j < items.length; j++) enhanceItem(items[j]);
    }
  }

  /* ---------- add to cart ------------------------------------------------ */

  function addToCart(item, button) {
    if (button.getAttribute(CONFIG.busyAttr) === 'true') return;

    var id = variantId(item);
    if (!id) {
      console.warn('[rebuy-cross-sell] Could not resolve a variant ID for', item);
      return;
    }

    var originalText = button.textContent;
    button.setAttribute(CONFIG.busyAttr, 'true');
    button.setAttribute('aria-busy', 'true');

    var body = new FormData();
    body.append('id', id);
    body.append('quantity', 1);

    // Global fetch is patched by Rebuy — this is what triggers the Smart Cart.
    fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: body
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data && data.status) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        button.setAttribute(CONFIG.doneAttr, 'true');
        button.textContent = CONFIG.addedText;

        window.setTimeout(function () {
          button.removeAttribute(CONFIG.doneAttr);
          button.textContent = originalText;
        }, CONFIG.addedDuration);
      })
      .catch(function (error) {
        console.error('[rebuy-cross-sell]', error);
        button.textContent = originalText;
      })
      .then(function () {
        button.removeAttribute(CONFIG.busyAttr);
        button.removeAttribute('aria-busy');
      });
  }

  /* ---------- delegated events ------------------------------------------- */

  // Capture phase: Rebuy binds its checkbox toggle further down the event
  // path, so stopping propagation here neutralises it without touching any
  // other click handling on the page.
  document.addEventListener('click', function (event) {
    var item = closest(event.target, CONFIG.item);
    if (!item || !closest(item, CONFIG.widget)) return;

    // "Add" button — add to cart, never navigate.
    var button = closest(event.target, CONFIG.addButton);
    if (button) {
      event.preventDefault();
      event.stopImmediatePropagation();
      addToCart(item, button);
      return;
    }

    // Our image / title links — let the browser navigate, but re-sync the
    // href first so a variant selected a moment ago is always reflected.
    var link = closest(event.target, '.' + CONFIG.linkClass);
    if (link) {
      var href = productUrl(item);
      if (href && link.getAttribute('href') !== href) link.setAttribute('href', href);
      event.stopImmediatePropagation();
      return;
    }

    // Any other click inside the title/image blocks (padding, gaps) must not
    // fall through to the original checkbox toggle.
    if (closest(event.target, CONFIG.title) || closest(event.target, CONFIG.image)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  // Variant change — Rebuy rewrites the Add link's href, so mirror it onto
  // our image/title links for correct hover targets and middle-click.
  document.addEventListener('change', function (event) {
    var select = closest(event.target, CONFIG.variantSelect);
    if (!select) return;

    var item = closest(select, CONFIG.item);
    if (!item || !closest(item, CONFIG.widget)) return;

    window.setTimeout(function () { enhanceItem(item); }, 0);
    window.setTimeout(function () { enhanceItem(item); }, 300);
  });

  /* ---------- (re)apply on async widget load ------------------------------ */

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      enhanceAll();
    });
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if ((node.matches && (node.matches(CONFIG.item) || node.matches(CONFIG.widget))) ||
            (node.querySelector && node.querySelector(CONFIG.item))) {
          schedule();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Belt and braces for the initial paint and Rebuy's own lifecycle events.
  ['rebuy:widget.ready', 'rebuy:widget.rendered', 'rebuy:cart.change'].forEach(function (name) {
    document.addEventListener(name, schedule);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }
})();